import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inspectionquote',
  templateUrl: './inspectionquote.component.html',
  styleUrls: ['./inspectionquote.component.css']
})
export class InspectionquoteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
